import { useState, useEffect, useRef } from 'react';
import StarRating from './StarRating';
import { useKey } from './useKey';
import { useLocalStorageState } from './useLocalStorageState';
import { useMovies } from './useMovies';

const KEY = 'e16232d';

const average = (arr) =>
	arr.reduce((acc, cur, _, arr) => acc + cur / arr.length, 0).toFixed(1);

export default function App() {
	const [query, setQuery] = useState('');
	const [selectedID, setSelectedID] = useState(null);
	// Point : for searching movies
	const { movies, isLoading, error } = useMovies(query);

	const [watched, setWatched] = useLocalStorageState([], 'watched');

	function handleSelectMovie(id) {
		setSelectedID((selectedID) => (id === selectedID ? null : id));
	}

	function handleCloseMovieDetails() {
		setSelectedID(null);
	}

	// Point: handleAddWatch Movie
	function handleAddWatchMovie(movie) {
		setWatched((watched) => [...watched, movie]);

		// localStorage.setItem('watch', JSON.stringify([...watched, movie]));
	}

	// Point: handleRemoveWatchMovie
	function handleDeleteWatchedMovie(id) {
		setWatched((watched) => watched.filter((movie) => movie.imdbID !== id));
	}

	return (
		<>
			<Navbar>
				<Search query={query} setQuery={setQuery} />
				<NumResults movies={movies} />
			</Navbar>

			<Main>
				<Box>
					{isLoading && <Loader />}

					{!isLoading && !error && (
						<MoviesList onSelectedMovie={handleSelectMovie} movies={movies} />
					)}

					{error && <ErrorMessage message={error} />}
				</Box>
				<Box>
					{selectedID ? (
						<MovieDetails
							watched={watched}
							onAddWatch={handleAddWatchMovie}
							onCloseMovie={handleCloseMovieDetails}
							selectedID={selectedID}
						/>
					) : (
						<>
							<WatchSummery watched={watched} />
							<WatchedMovieList
								watched={watched}
								onDeleteMovie={handleDeleteWatchedMovie}
							/>
						</>
					)}
				</Box>
			</Main>
		</>
	);
}
// Point : Error Message
function ErrorMessage({ message }) {
	return (
		<p className='error'>
			{' '}
			<span>🛑</span> {message}
		</p>
	);
}

// Point:: lOADER MESSAGE
function Loader() {
	return <h1 className='loader'>Loading...</h1>;
}

// Point: Navbar
function Navbar({ children }) {
	return (
		<nav className='nav-bar'>
			{' '}
			<Logo />
			{children}
		</nav>
	);
}

// Point : Logo
function Logo() {
	const [fadeOut, setFadeOut] = useState(false);

	const logoStyle = {
		cursor: 'pointer',
		transition: 'opacity 0.5s',
		opacity: fadeOut ? 0 : 1,
	};

	function handleLogoClick() {
		setFadeOut(true);

		setTimeout(() => {
			window.location.reload();
		}, 500);
	}

	return (
		<div className='logo' onClick={handleLogoClick} style={logoStyle}>
			<span role='img'>🍿</span>
			<h1>usePopcorn</h1>
		</div>
	);
}

// Point : Search Query(movie)
function Search({ query, setQuery }) {
	const inputEl = useRef(null);

	useKey('Enter', function () {
		if (document.activeElement === inputEl.current) return;
		inputEl.current.focus();
		setQuery('');
	});

	return (
		<input
			className='search'
			type='text'
			placeholder='Search movies...'
			value={query}
			onChange={(e) => setQuery(e.target.value)}
			ref={inputEl}
		/>
	);
}

// Point : Movies List
function NumResults({ movies }) {
	return (
		<p className='num-results'>
			Found <strong>{movies.length}</strong> results
		</p>
	);
}

// Point : Main Content(movie list)
function Main({ children }) {
	return <main className='main'>{children}</main>;
}

// Point : Movies List(box)
function Box({ children }) {
	const [isOpen, setIsOpen] = useState(true);

	return (
		<div className='box'>
			<button className='btn-toggle' onClick={() => setIsOpen((open) => !open)}>
				{isOpen ? '–' : '+'}
			</button>
			{isOpen && children}
		</div>
	);
}

// Point : Movie Details
function MovieDetails({ watched, selectedID, onCloseMovie, onAddWatch }) {
	const [movie, setMovie] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState('');
	const [userRating, setUserRating] = useState('');

	const countRating = useRef(0);

	useEffect(
		function () {
			if (userRating) countRating.current = countRating.current + 1;
			// if (userRating) countRating.current ++;
		},
		[userRating],
	);

	// const isWatched = watched.map((movie) => movie.imdbID).includes(selectedID); /// old way

	const isWatched = watched.some((movie) => movie.imdbID === selectedID); /// new way
	const watchedUserRating = watched.find(
		(movie) => movie.imdbID === selectedID,
	)?.userRating;
	const {
		Director: director,
		Genre: genre,
		Poster: poster,
		Released: released,
		Runtime: runtime,
		Title: title,
		Year: year,
		imdbRating,
		Plot: plot,
		Actors: actors,
	} = movie;

	const isTop = imdbRating > 8;
	console.log(isTop);

	function handleAdd() {
		if (!userRating) return;

		const newWatchedMovie = {
			imdbID: selectedID,
			title,
			year,
			poster,
			imdbRating: Number(imdbRating),
			runtime: Number(runtime.split(' ')[0]), /// old
			// runtime: Number(runtime.split(' ').at(0)), /// new
			userRating,
			userCountRatingDecision: countRating.current,
		};

		onAddWatch(newWatchedMovie);
		onCloseMovie();
	}

	// Point : for KeyPress (ESC)'
	useKey('Escape', onCloseMovie);

	// Point : Fetching the movie details
	useEffect(
		function () {
			async function getMoviesDetails() {
				try {
					setIsLoading(true);
					setError('');
					const res = await fetch(
						`https://www.omdbapi.com/?apikey=${KEY}&i=${selectedID}`,
					);

					if (!res.ok) throw new Error('Something went wrong ! ');

					const data = await res.json();

					if (data.Response === 'False') throw new Error(' Failed to fetch');

					setMovie(data);
				} catch (error) {
					console.log(error.message);
					setError(error.message);
				} finally {
					setIsLoading(false);
				}
			}
			getMoviesDetails();
		},
		[selectedID],
	);

	// Point : Changing the title of the page
	useEffect(() => {
		if (!title) return; // / guard clause
		document.title = `movie | ${title}`;

		return () => (document.title = 'usePopcorn');
	}, [title]);

	return (
		<div className='details'>
			{isLoading ? (
				<Loader />
			) : error ? (
				<ErrorMessage message={error} />
			) : (
				<>
					<header>
						<button onClick={onCloseMovie} className='btn-back'>
							&larr;
						</button>

						<img src={poster} alt={`poster of the ${movie}`} />

						<div className='details-overview'>
							<h2>{title}</h2>
							<p>
								{released} &bull; {runtime}{' '}
							</p>
							<p>{genre}</p>
							<p>
								{' '}
								<span> ⭐ </span>
								{imdbRating} IMDb rating
							</p>
						</div>
					</header>

					<section>
						<div className='rating'>
							{!isWatched ? (
								<>
									<StarRating
										onMovieRating={setUserRating}
										maxRating={10}
										size={24}
									/>
									{userRating ? (
										<button onClick={handleAdd} className='btn-add'>
											+ Add to list
										</button>
									) : (
										''
									)}
								</>
							) : (
								<p>
									Already Added to the List with {watchedUserRating} ⭐ rating{' '}
								</p>
							)}
						</div>

						<p>
							<em>{plot}</em>
						</p>
						<p>Actors : {actors}</p>
						<p>Directed By {director}</p>
					</section>
				</>
			)}
		</div>
	);
}

// Point : Movies List Component
function MoviesList({ movies, onSelectedMovie }) {
	return (
		<ul className='list list-movies'>
			{movies?.map((movie) => (
				<Movie
					onSelectedMovie={onSelectedMovie}
					movie={movie}
					key={movie.imdbID}
				/>
			))}
		</ul>
	);
}

// Point : SIngle Movie component
function Movie({ movie, onSelectedMovie }) {
	return (
		<li onClick={() => onSelectedMovie(movie.imdbID)} key={movie.imdbID}>
			<img src={movie.Poster} alt={`${movie.Title} poster`} />
			<h3>{movie.Title}</h3>
			<div>
				<p>
					<span>🗓</span>
					<span>{movie.Year}</span>
				</p>
			</div>
		</li>
	);
}

// Point : Watched Movies List Component (watch later)
function WatchSummery({ watched }) {
	const avgImdbRating = average(watched.map((movie) => movie.imdbRating));
	const avgUserRating = average(watched.map((movie) => movie.userRating));
	const avgRuntime = average(watched.map((movie) => movie.runtime));

	return (
		<div className='summary'>
			<h2>Movies you watched</h2>
			<div>
				<p>
					<span>#️⃣</span>
					<span>{watched.length} movies</span>
				</p>
				<p>
					<span>⭐️</span>
					<span>{avgImdbRating}</span>
				</p>
				<p>
					<span>🌟</span>
					<span>{avgUserRating}</span>
				</p>
				<p>
					<span>⏳</span>
					<span>{avgRuntime} min</span>
				</p>
			</div>
		</div>
	);
}

// Point : LIST OF WATCHED MOVIES
function WatchedMovieList({ watched, onDeleteMovie }) {
	return (
		<ul className='list'>
			{watched.map((movie) => (
				<WatchedMovie
					onDeleteMovie={onDeleteMovie}
					movie={movie}
					key={movie.imdbID}
				/>
			))}
		</ul>
	);
}

// Point : Single Watched Movie
function WatchedMovie({ movie, onDeleteMovie }) {
	return (
		<li key={movie.imdbID}>
			<img src={movie.poster} alt={`${movie.title} poster`} />
			<h3>{movie.title}</h3>
			<div>
				<p>
					<span>⭐️</span>
					<span>{movie.imdbRating}</span>
				</p>
				<p>
					<span>🌟</span>
					<span>{movie.userRating}</span>
				</p>
				<p>
					<span>⏳</span>
					<span>{movie.runtime} min</span>
				</p>
				<button
					className='btn-delete'
					onClick={() => onDeleteMovie(movie.imdbID)}
				>
					X
				</button>
			</div>
		</li>
	);
}
